import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoice-history"
export default class extends Controller {
  static targets = ["form"]

  connect() {
  }

  async clickedSubmit(event){
    event.preventDefault();
    if(!this.formTarget.checkValidity()){
      this.formTarget.classList.add("was-validated")
    }else{
      this.formTarget.submit()
    }
  }
}
